/**
 * Typography Design Tokens - Sólido Business Law
 * Inspirado en el estilo minimalista y bold de Viralistic
 */

export const typography = {
  // Font Families - Arial con fallbacks
  fontFamily: {
    primary: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    accent: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    mono: '"Courier New", Courier, monospace',
  },

  // Font Weights - Enfoque en bold
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  // Font Sizes - Más grandes para impacto
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
    '6xl': '3.75rem', // 60px
    '7xl': '4.5rem',  // 72px
    '8xl': '6rem',    // 96px
    '9xl': '8rem',    // 128px
  },

  // Line Heights - Más tight para impacto
  lineHeight: {
    none: 1,
    tight: 1.1,
    snug: 1.2,
    normal: 1.4,
    relaxed: 1.6,
    loose: 1.8,
  },

  // Letter Spacing
  letterSpacing: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
} as const;

export type Typography = typeof typography;